<template>
    <ui-crud title="Toolbox Talks" subtitle="A list of all available toolbox talks"
             :fetch="fetch" :pipe-with="pipeItems">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.reference} - ${item.title}`"
                :subtitle="item.lastUpdatedOn?`${item.lastUpdatedAt.format('MMMM Do YYYY, h:mm:ss a')}`:`${item.createdAt.format('MMMM Do YYYY, h:mm:ss a')}`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <toolbox-talk-library-item-form :add-item="addItem"></toolbox-talk-library-item-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <toolbox-talk-library-item-form :item="selectedItem" :edit="setEditMode"></toolbox-talk-library-item-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <toolbox-talk-library-item-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" @print="print"
                                :add-item="addItem"></toolbox-talk-library-item-show>
        </template>
    </ui-crud>
</template>

<script>
import {ToolboxTalkLibraryItem} from "@models";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import UiInput from "../../ui/UiInput.vue";
import moment from "moment/moment";

export default {
    components: {UiInput, UiCrudCard},
    props: {
        admin: Boolean,
    },
    data() {
        return {
            search: '',
            toolboxTalkLibraryItems: [],
        }
    },
    methods: {
        async fetch() {
            return await ToolboxTalkLibraryItem.all()
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((route) => {
                    return query.every((token) => {
                        return route.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
                document.body.appendChild(this.iframe);
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        }
    },
    async mounted() {
        this.toolboxTalkLibraryItems = await ToolboxTalkLibraryItem.all()
    }
};
</script>
